/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_updateCountryRequest } from '../models/api_updateCountryRequest';
import type { db_GetCountryRow } from '../models/db_GetCountryRow';
import type { db_ListCountriesRow } from '../models/db_ListCountriesRow';
import type { db_ListCountriesSearchRow } from '../models/db_ListCountriesSearchRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Countries {
    /**
     * Get a list of countries
     * @param isCheveningEligible Filter to countries eligible for Chevening
     * @returns db_ListCountriesRow OK
     * @throws ApiError
     */
    public static listCountries(
        isCheveningEligible?: boolean,
    ): CancelablePromise<Array<db_ListCountriesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/countries',
            query: {
                'is_chevening_eligible': isCheveningEligible,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of countries for search
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListCountriesSearchRow OK
     * @throws ApiError
     */
    public static listCountriesSearch(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListCountriesSearchRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/countries-search',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a country by ID
     * @param id Country ID
     * @returns db_GetCountryRow OK
     * @throws ApiError
     */
    public static getCountry(
        id: number,
    ): CancelablePromise<db_GetCountryRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/countries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a country
     * @param id Country ID
     * @param body Country update request
     * @returns void
     * @throws ApiError
     */
    public static updateCountry(
        id: number,
        body: api_updateCountryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/countries/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of countries available to the authenticated user
     * @returns db_ListCountriesRow OK
     * @throws ApiError
     */
    public static listUserCountries(): CancelablePromise<Array<db_ListCountriesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user-countries',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
